import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const ApexHero = () => {
  const navigate = useNavigate();

  const goToApplication = () => {
    navigate('/5k-guarantee#application');
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-[#0A0A0A]">
      {/* Clean minimal background */}
      <div className="absolute inset-0 bg-[#0A0A0A]" />
      
      {/* Subtle accent glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#22C55E]/5 rounded-full blur-[200px]" />
      
      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 py-32 md:py-40">
        <div className="text-center space-y-8">
          {/* Minimal badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#27272A]">
            <span className="w-1.5 h-1.5 bg-[#22C55E] rounded-full" />
            <span className="text-[#71717A] text-xs font-medium tracking-widest uppercase">
              Fitness Sales Specialists
            </span>
          </div>

          {/* Clean headline */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-[1.05] tracking-tight">
            Stop Fearing Sales.
            <br />
            <span className="text-[#22C55E]">Start Filling Your Gym.</span>
          </h1>

          {/* Minimal subheadline */}
          <p className="text-lg md:text-xl text-[#71717A] leading-relaxed max-w-2xl mx-auto">
            We transform the sales conversation into your competitive advantage — 
            no pushy tactics, just a proven process that fills your gym.
          </p>

          {/* Stats - cleaner layout */}
          <div className="flex justify-center gap-12 md:gap-16 pt-4">
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-bold text-white">28%</p>
              <p className="text-xs text-[#52525B] uppercase tracking-wider mt-1">Avg. Increase</p>
            </div>
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-bold text-white">8,000+</p>
              <p className="text-xs text-[#52525B] uppercase tracking-wider mt-1">Consultations</p>
            </div>
            <div className="text-center">
              <p className="text-3xl md:text-4xl font-bold text-white">1-to-1</p>
              <p className="text-xs text-[#52525B] uppercase tracking-wider mt-1">Coaching</p>
            </div>
          </div>

          {/* CTA buttons - cleaner */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-6">
            <button
              onClick={goToApplication}
              data-testid="hero-cta-primary"
              className="group inline-flex items-center justify-center gap-2 bg-[#22C55E] hover:bg-[#16A34A] text-black font-semibold tracking-wide rounded-full px-8 py-4 transition-all duration-300"
            >
              Book Your Free Audit
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
            <a
              href="#calculator"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center justify-center gap-2 text-[#71717A] hover:text-white font-medium rounded-full px-8 py-4 transition-colors duration-300"
            >
              Calculate Your Revenue
            </a>
          </div>
        </div>
      </div>

      {/* Minimal bottom line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#27272A] to-transparent" />
    </section>
  );
};

export default ApexHero;
